/**
 * Reference List  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { ItemList } from "../ItemList/ItemList";
import { ItemListGroup } from "../ItemList/ItemListGroup";
import { ItemListRow } from "../ItemList/ItemListRow";
import { getResourceTypeData } from "../../../common/ResourceHelpers";
import { ItemListRowMessage } from "../ItemList/ItemListRowMessage";
import { ItemListRowDetails } from "../ItemList/ItemListRowDetails";

export interface IReferenceListItem {
	id: string;
	name: string;
	resourceType: RESOURCE_TYPES;
	basePath: string;
}

export interface IReferenceListProps {
	referencedBy: IReferenceListItem[];
	dependsOn: IReferenceListItem[];
	onItemClick?: (ref: IReferenceListItem) => void;
	className?: string;
}

export const ReferenceList: React.FC<IReferenceListProps> = ({
	referencedBy,
	dependsOn,
	onItemClick,
	className
}) => {
	return (
		<ItemList className={className}>
			<ItemListGroup label="Referenced By" count={referencedBy.length} collapsible={true} isDefaultCollapsed={false}>
				{
					referencedBy.map((item) => {
						const type = getResourceTypeData(item.resourceType);

						return (
							<ItemListRow
								key={item.id}
								icon={type.icon}
								rowData={item}
								onClick={onItemClick}
								className={`edt-icon-color--resource-type-${type.typeMod}`}
							>
								<ItemListRowMessage>{item.name}</ItemListRowMessage>
								<ItemListRowDetails>{item.basePath}</ItemListRowDetails>
							</ItemListRow>
						);
					})
				}
			</ItemListGroup>
			<ItemListGroup label="Depends On" count={dependsOn.length} collapsible={true} isDefaultCollapsed={false}>
				{
					dependsOn.map((item) => {
						const type = getResourceTypeData(item.resourceType);

						return (
							<ItemListRow
								key={item.id}
								icon={type.icon}
								rowData={item}
								onClick={onItemClick}
								className={`edt-icon-color--resource-type-${type.typeMod}`}
							>
								<ItemListRowMessage>{item.name}</ItemListRowMessage>
								<ItemListRowDetails>{item.basePath}</ItemListRowDetails>
							</ItemListRow>
						);
					})
				}
			</ItemListGroup>
		</ItemList>
	);
};